<template>
  <div>
    <action-header
      v-if="!hasValidRole(role, [Role.Student, Role.Family])"
      :button="buttonSearch"
      :data.sync="studentCode"
      @studentValue="studentCode = $event"
      :pathConnect="pathConnect"
      @export-pdf="exportPdf()"
      :show-export="showExport"
      ref="actionHeader"
    >
    </action-header>
    <div v-else class="md-layout hidden lg:block">
      <div class="md-layout-item text-right">
        <md-button
          class="md-warning"
          @click.prevent="exportPdf()"
          v-if="showExport"
        >
          {{ $t("common.export") }}
        </md-button>
      </div>
    </div>
    <student-information :data="infoStudent">
      <md-card class="rounded-xl">
        <md-card-header class=" md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("smi_sri.sbac_detail") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div v-if="sbacScoreTable">
            <md-table class="format-table md-scrollbar">
              <md-table-row class="text-center">
                <md-table-head class="pl-6">{{
                  $t("smi_sri.grade")
                }}</md-table-head>
                <md-table-head class="pl-6">{{
                  $t("smi_sri.assessment_name")
                }}</md-table-head>
                <md-table-head class="pl-6">{{
                  $t("smi_sri.score_result")
                }}</md-table-head>
                <md-table-head class="pl-6">{{
                  $t("smi_sri.achievement_level")
                }}</md-table-head>
                <md-table-head class="pl-6">{{
                  $t("smi_sri.level_or_proficiency")
                }}</md-table-head>
                <md-table-head class="pl-6">{{
                  $t("smi_sri.assessment_family_achievement_level")
                }}</md-table-head>
                <md-table-head class="pl-6">{{
                  $t("smi_sri.assessment_school_year")
                }}</md-table-head>
              </md-table-row>

              <template>
                <md-table-row
                  class="text-center"
                  v-for="(scoreTable, index) in sbacScoreTable"
                  :key="index + 'scoreTable'"
                >
                  <md-table-cell>{{ scoreTable.grade }} </md-table-cell>
                  <md-table-cell
                    >{{ scoreTable.assessmentName }}
                  </md-table-cell>
                  <md-table-cell>{{ scoreTable.scoreResult }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.achievementLevel
                  }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.levelOrProficiency
                  }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.assessmentFamilyAchievementLevel
                  }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.assessmentSchoolYear
                  }}</md-table-cell>
                </md-table-row>
              </template>
            </md-table>
          </div>
          <div v-else>
            <no-data-found></no-data-found>
          </div>
        </md-card-content>
      </md-card>
    </student-information>
    <div v-if="showExport">
      <pdf-default ref="pdfContent" pdf-format="letter">
        <template #pdf-content>
          <export-pdf-sbac
            :info="infoStudent"
            :data-table="sbacScoreTable"
          ></export-pdf-sbac>
        </template>
      </pdf-default>
    </div>
  </div>
</template>
<script>
import ActionHeader from "./ActionHeader";
import { service_names } from "@/constants/Services";
import StudentInformation from "../Components/StudentInfomation";
import AWSConst from "@/constants/AWS";
import pick from "lodash/pick";
import { convertObj, Message, getId } from "@/helpers/utils";
import NoDataFound from "@/components/Base/Illustration/NoDataFound.vue";
import { mapGetters, mapState } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import PdfDefault from "../../../components/PdfDefault";
import ExportPdfSbac from "./ExportPdfSbac";

export default {
  components: {
    ExportPdfSbac,
    PdfDefault,
    StudentInformation,
    ActionHeader,
    NoDataFound
  },
  data() {
    return {
      Role,
      hasValidRole,
      buttonSearch: {
        title: "common.search",
        action: this.getSbacStudentInfo
      },
      infoStudent: null,
      studentCode: null,
      sbacScoreTable: null,
      //config import xlsx
      pathConnect: {
        templateLinks: `${service_names.school}/sbac/template`,
        templateName: "template-sbac.xlsx",
        pathSaveUploadedLink: `${service_names.school}/sbac/import`,
        S3ImportACTPath: AWSConst.S3_IMPORT_SBAC_PATH
      },
      showExport: false
    };
  },
  watch: {
    studentCode: function(newVal) {
      this.infoStudent = null;
      this.sbacScoreTable = null;
      this.showExport = false;
    }
  },
  computed: {
    ...mapState("switchAccountChild", ["currentChild"]),
    ...mapGetters("user", ["role", "info"])
  },
  mounted() {
    if (hasValidRole(this.role, Role.Student)) {
      this.studentCode = getId(this.info);
      this.getSbacStudentInfo();
    }

    if (hasValidRole(this.role, Role.Family)) {
      this.studentCode = getId(this.currentChild);
      this.getSbacStudentInfo();
    }

    const query = this.$route.query;
    if (!hasValidRole(this.role, Role.Student) && query.tabName === "SBAC") {
      this.setInfoStudentByQuery(query);
    }
  },
  methods: {
    setInfoStudentByQuery(query) {
      this.studentCode = query.id;
      this.getSbacStudentInfo();
      this.$router.replace({ query: {} });
    },
    getSbacStudentInfo() {
      const studentCode = this.studentCode;
      if (!studentCode) {
        Message.error(
          this.$t("smi_sri.please_select_the_student_to_view_report")
        );
        return;
      }
      return this.$axios
        .get(`${service_names.school}/sbac/user/${studentCode}`)
        .then(response => {
          if (!response.data) return;
          const data = convertObj.snakeCaseToCamelCase(response.data);
          this.infoStudent = pick(data, [
            "avatarUrl",
            "studentCode",
            "fullName",
            "grade"
          ]);
          if (!hasValidRole(this.role, [Role.Student, Role.Family])) {
            this.$refs.actionHeader.studentData.displayValue =
              this.infoStudent.fullName +
                " - " +
                this.infoStudent.studentCode || "";
          }
          if (data.sbacs?.length) {
            this.sbacScoreTable = data.sbacs;
            this.showExport = true;
          }
        });
    },
    exportPdf() {
      this.$refs.pdfContent.generatePdf();
    }
  }
};
</script>
<style lang="scss" scoped>
.md-table-head {
  padding: 12px 8px;
  text-align: center;
  border: 0.5px solid #b8b7b7;
}
.md-table-cell {
  border: 0.5px solid #b8b7b7;
}
</style>
